import React from "react";
import House from "../../Assets/images/houso.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function AwaitInvite({ rental }) {
  const data = rental?.rentals?.[0] || rental;
  return (
    <div className="bg-white border border-gray-100 mb-4 shadow-sm rounded-xl p-4">
      <div className="flex justify-between gap-4">
        {/* Left Image */}
        <div className="w-[120px] md:w-[140px]">
          <img
            src={data?.apartmentImages?.[0]?.imageUrl || House}
            alt=""
            className="w-full object-cover rounded-lg"
          />
        </div>

        {/* Right Content */}
        <div className="flex flex-col flex-1">
          <div className="flex justify-between items-start mb-1">
            <h3 className="text-[#1E222B] font-[600] text-[16px]">
              {data?.title}
            </h3>
            <p className="text-[#1A1A1B] font-[600] rounded-md py-1 px-3 text-[12px] bg-[#FFF3D6]">
              Awaiting Invite
            </p>
          </div>
          <p className="text-[#1E222B] font-[600] text-[16px] mb-1">
            {`(Rooms: ${data?.bedrooms || 0})`}
          </p>
          <p className="text-[#1E222B] font-semibold text-[13px] mb-2">
            Property ID: {data?.id}
          </p>

          <div className="bg-[#F8FAFC] rounded-lg p-2 flex gap-1 items-start mt-auto">
            <InfoOutlinedIcon
              className="text-[#2AC780]"
              sx={{ fontSize: 18, marginTop: "2px" }}
            />
            <div className="">
              <p className="text-[#1A1A1B] text-[12px] font-bold leading-[150%]">
                Your request is being reviewed by the landlord.
              </p>
              <p className="text-[#2AC780] leading-[150%] text-[12px] font-semibold">
                You will be notified once the application is processed and
                invite is sent
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AwaitInvite;
